import Icon from '@ant-design/icons';
import { Flex } from 'antd';
import React from 'react';
import IconNotes from '~/assets/svg/icon-notes.svg?react';
import TimeNotification from '~/components/screens/Conversations/ConversationsList/TimeNotification';

function ConversationListItem({ conversation, isSelected, onSelect }) {
  const isUnread = !conversation.read_by_merchant;

  return (
    <Flex
      onClick={() => onSelect(conversation.id)}
      vertical
      gap={8}
      className={`p-m border-b border-x-0 border-t-0 border-solid border-grey cursor-pointer ${isSelected ? 'conversation-item--selected' : ''}`}
    >
      <Flex justify='space-between' align='center' gap={10}>
        <p className={`${isUnread ? 'body2' : 'body1'} text-ellipsis line-clamp-1 break-all`}>
          {!conversation.user.deleted ? `${conversation.user.first_name} ${conversation.user.last_name}` : 'Utilisateur supprimé'}
        </p>
        <TimeNotification conversation={conversation} />
      </Flex>
      {conversation.contact_reason_label && <p className={`${isUnread ? 'caption2' : 'caption1'} text-grey-medium`}>{conversation.contact_reason_label}</p>}
      {conversation.last_note && (
        <Flex className='border border-solid border-grey bg-grey-light rounded-sm p-xs' gap={4} align='center' justify='space-between'>
          <p className='body1 text-grey-medium line-clamp-1'>{conversation.last_note.content}</p>
          <Icon component={IconNotes} className='text-[24px] shrink-0' />
        </Flex>
      )}
    </Flex>
  );
}

export default ConversationListItem;
